import APIS_CONSTANTS from "./ApiConstants";
import ChatSocketHttp from "./ChatSocketHttp";

class ChatSocketServices {
  jwtToken(OrgUserToken) {
    // Get token from Redux store instead of making API call
    // Return a proper response structure that matches what the slice expects
    return Promise.resolve({ data: { token: OrgUserToken } });
  }

  getUserData(jwtToken) {
    return ChatSocketHttp.get(APIS_CONSTANTS.getUserData, {
      headers: {
        Token: jwtToken,
      },
    });
  }

  // createChat({ jwtToken, access, organizationId, botName }) {
  //   return ChatSocketHttp.post(
  //     APIS_CONSTANTS.createChat,
  //     {
  //       organizationId,
  //       access,
  //       botName
  //     },
  //     {
  //       headers: {
  //         Token: jwtToken,
  //       },
  //     }
  //   );
  // }

  // getMessagesHistory({ jwtToken, userChatId }) {
  //   return ChatSocketHttp.get(
  //     `${APIS_CONSTANTS.getMessagesHistory}/${userChatId}`,
  //     {
  //       headers: {
  //         Token: jwtToken,
  //       },
  //     }
  //   );
  // }

  sendMessage({ jwtToken, userChatId, content, botName, pageContext }) {
    return ChatSocketHttp.post(
      APIS_CONSTANTS.sendMessage,
      {
        content,
        botName,
        chatId: userChatId,
        ...(pageContext ? { pageContext } : {}),
      },
      {
        headers: {
          Token: jwtToken,
        },
      }
    );
  }

  sendMessageForBot({ jwtToken, userChatId, content, botName, pageContext }) {
    return ChatSocketHttp.post(
      APIS_CONSTANTS.sendMessageToBot,
      {
        content,
        botName,
        chatId: userChatId,
        ...(pageContext ? { pageContext } : {}),
      },
      {
        headers: {
          Token: jwtToken,
        },
      }
    );
  }
}

export default new ChatSocketServices();
